export default __webpack_public_path__ + "static/leavingCrumbled-a0e7864c1ccdff329f0dd32be8a308f6.svg";